import React, { Component } from 'react';
import browserHistory from '../../history';
import { connect } from 'react-redux';
import axios from 'axios';
import { location } from '../../utils/utils';
import heirloomLogo from '../../assets/heirloom.png';
let menus = [
     {
        menu: 'Search',
        menuId: 'AISearch',
        route: '/ai-search',
        icon: 'database_search'
    },
    {
        menu: 'Live TV',
        menuId: 'Live TV',
        route: '/',
        icon: 'video_library'
    },
    // {
    //     menu: 'On Demand',
    //     menuId: 'On Demand',
    //     route: '/onDemand'
    // },
    {
        menu: 'Movies',
        menuId: 'Movies',
        route: '/movies',
        icon: 'movie'
    },
    {
        menu: 'Shows',
        menuId: 'Shows',
        route: '/shows',
        icon: 'tv'
    },
    // {
    //     menu: 'Podcasts',
    //     menuId: 'Podcasts',
    //     route: '/podcasts'
    // },
]

let adidasboxingMenus = [
  
     {
        menu: 'Search',
        menuId: 'AISearch',
        route: '/ai-search',
        icon: 'database_search'
    },
      {
        menu: 'Live TV',
        menuId: 'Live TV',
        route: '/',
        icon: 'video_library'
    },
    {
        menu: 'Home',
        menuId: 'Home',
        route: '/home',
        icon: 'home'
    },
   
    {
        menu: 'Movies',
        menuId: 'Movies',
        route: '/movies',
        icon: 'movie'
    },
    {
        menu: 'TV Shows',
        menuId: 'Shows',
        route: '/shows',
        icon: 'tv'
    },
    {
        menu: 'Podcasts',
        menuId: 'Podcasts',
        route: '/podcasts',
        icon: 'podcasts'
    },
    {
        menu: 'Music Videos',
        menuId: 'MusicVideos',
        route: '/musicvideos',
        icon: 'music_video'
    },
    {
        menu: 'Interviews',
        menuId: 'Interviews',
        route: '/interviews',
        icon: 'mic_double'
    },
]

let elevenMenus = [
    
     {
        menu: 'Search',
        menuId: 'AISearch',
        route: '/ai-search',
        icon: 'database_search'
    },
    {
        menu: 'Live TV',
        menuId: 'Live TV',
        route: '/',
        icon: 'video_library'
    },
    {
        menu: 'Home',
        menuId: 'Home',
        route: '/home',
        icon: 'home'
    },
    
    {
        menu: 'Movies',
        menuId: 'Films',
        route: '/movies',
        icon: 'movie'
    },
    {
        menu: 'TV Shows',
        menuId: 'Tv Shows',
        route: '/shows',
        icon: 'tv'
    },
    {
        menu: 'Music Videos',
        menuId: 'Music Videos',
        route: '/musicvideos',
        icon: 'music_video'
    },
    {
        menu: 'Interviews',
        menuId: 'Interviews',
        route: '/interviews',
        icon: 'mic_double'
    },
]

let usaboxingMenus = [
    
    {
        menu: 'Search',
        menuId: 'AISearch',
        route: '/ai-search',
        icon: 'database_search'
    },
    {
        menu: 'Live TV',
        menuId: 'Live TV',
        route: '/',
        icon: 'video_library'
    },
    {
        menu: 'Home',
        menuId: 'Home',
        route: '/home',
        icon: 'home'
    },
    
    {
        menu: 'TV Shows',
        menuId: 'Tv Shows',
        route: '/shows',
        icon: 'tv'
    },
    {
        menu: 'Interviews',
        menuId: 'Interviews',
        route: '/interviews',
        icon: 'mic_double'
    },
    {
        menu: 'Podcasts',
        menuId: 'Podcasts',
        route: '/podcasts',
        icon: 'podcasts'
    },
    {
        menu: 'Commercials',
        menuId: 'Commercials',
        route: '/commercials',
        icon: 'shop'
    }

]

let westlosangelescollegeMenus = [
    // {
    //     menu: 'Home',
    //     menuId: 'Home',
    //     route: '/home',
    //     icon: 'home'
    // },
    
    {
        menu: 'Search',
        menuId: 'AISearch',
        route: '/ai-search',
        icon: 'database_search'
    },
    {
        menu: 'Live TV',
        menuId: 'Live TV',
        route: '/',
        icon: 'video_library'
    },
    {
        menu: 'TV Shows',
        menuId: 'Tv Shows',
        route: '/shows',
        icon: 'tv'
    },
    {
        menu: 'Interviews',
        menuId: 'Interviews',
        route: '/interviews',
        icon: 'mic_double'
    },
    {
        menu: 'Podcasts',
        menuId: 'Podcasts',
        route: '/podcasts',
        icon: 'podcasts'
    },
    {
        menu: 'Commercials',
        menuId: 'Commercials',
        route: '/commercials',
        icon: 'shop'
    }

]

let kardashianMenus = [
    
    {
        menu: 'Search',
        menuId: 'AISearch',
        route: '/ai-search',
        icon: 'database_search'
    },
    {
        menu: 'Live TV',
        menuId: 'Live TV',
        route: '/',
        icon: 'video_library'
    },
    {
        menu: 'Movies',
        menuId: 'Films',
        route: '/movies',
        icon: 'movie'
    },
    {
        menu: 'TV Shows',
        menuId: 'Tv Shows',
        route: '/shows',
        icon: 'tv'
    },
    {
        menu: 'Music Videos',
        menuId: 'Music Videos',
        route: '/musicvideos',
        icon: 'music_video'
    },
    {
        menu: 'Interviews',
        menuId: 'Interviews',
        route: '/interviews',
        icon: 'mic_double'
    },
    {
        menu: 'Commercials',
        menuId: 'Commercials',
        route: '/commercials',
        icon: 'podcasts'
    },
]


let heirloomMenus = [
    
    {
        menu: 'Search',
        menuId: 'AISearch',
        route: '/ai-search',
        icon: 'database_search'
    },
    {
        menu: 'Live TV',
        menuId: 'Live TV',
        route: '/',
        icon: 'video_library'
    },
    {
        menu: 'Home',
        menuId: 'Home',
        route: '/home',
        icon: 'home'
    },
    {
        menu: 'Family',
        menuId: 'Family',
        route: '/family',
        icon: 'family_restroom'
    },
    {
        menu: 'Siblings',
        menuId: 'Siblings',
        route: '/siblings',
        icon: 'people'
    },
    {
        menu: 'Friends',
        menuId: 'Friends',
        route: '/friends',
        icon: 'group'
    },
    {
        menu: 'Channels',
        menuId: 'Channels',
        route: '/channels',
        icon: 'live_tv'
    },
    
]

let paffMenus = [
     {
        menu: 'Search',
        menuId: 'AISearch',
        route: '/ai-search',
        icon: 'database_search'
    },
    {
        menu: 'Live TV',
        menuId: 'Live TV',
        route: '/',
        icon: 'video_library'
    },
    {
        menu: 'Movies',
        menuId: 'Films',
        route: '/movies',
        icon: 'movie'
    },
    {
        menu: 'TV Shows',
        menuId: 'Tv Shows',
        route: '/shows',
        icon: 'tv'
    }
]


let hollylandMenus = [
     {
        menu: 'Search',
        menuId: 'AISearch',
        route: '/ai-search',
        icon: 'database_search'
    },
    {
        menu: 'Live TV',
        menuId: 'Live TV',
        route: '/',
        icon: 'video_library'
    },
    {
        menu: 'Interviews',
        menuId: 'Interviews',
        route: '/interviews',
        icon: 'mic_double'
    },
    {
        menu: 'Podcasts',
        menuId: 'Podcasts',
        route: '/podcasts',
        icon: 'podcasts'
    },
]

let screenixxMenus = [
    
     {
        menu: 'Search',
        menuId: 'AISearch',
        route: '/ai-search',
        icon: 'database_search'
    },
    {
        menu: 'Live TV',
        menuId: 'Live TV',
        route: '/',
        icon: 'video_library'
    },
    {
        menu: 'Home',
        menuId: 'Home',
        route: '/home',
        icon: 'home'
    },
    
    {
        menu: 'Movies',
        menuId: 'Films',
        route: '/movies',
        icon: 'movie'
    },
    {
        menu: 'TV Shows',
        menuId: 'TV Shows',
        route: '/series',
        icon: 'tv'
    },
    {
        menu: 'Music Videos',
        menuId: 'Music Videos',
        route: '/musicvideos',
        icon: 'music_video'
    },
    {
        menu: 'Interviews',
        menuId: 'Interviews',
        route: '/interviews',
        icon: 'mic_double'
    },
    {
        menu: 'Commercials',
        menuId: 'Commercials',
        route: '/commercials',
        icon: 'shop'
    },
    {
        menu: 'Podcasts',
        menuId: 'Podcasts',
        route: '/podcasts',
        icon: 'podcasts'
    },
]


let marinadelreyfilmfestivalMenus = [
    
     {
        menu: 'Search',
        menuId: 'AISearch',
        route: '/ai-search',
        icon: 'database_search'
    },
    {
        menu: 'Live TV',
        menuId: 'Live TV',
        route: '/',
        icon: 'video_library'
    },
    {
        menu: 'Home',
        menuId: 'Home',
        route: '/home',
        icon: 'home'
    },
    
    {
        menu: 'Movies',
        menuId: 'Films',
        route: '/movies',
        icon: 'movie'
    },
    {
        menu: 'TV Shows',
        menuId: 'TV Shows',
        route: '/series',
        icon: 'tv'
    },
    // {
    //     menu: 'Music Videos',
    //     menuId: 'Music Videos',
    //     route: '/musicvideos',
    //     icon: 'music_video'
    // },
    // {
    //     menu: 'Interviews',
    //     menuId: 'Interviews',
    //     route: '/interviews',
    //     icon: 'mic_double'
    // },
    {
        menu: 'Commercials',
        menuId: 'Commercials',
        route: '/commercials',
        icon: 'podcasts'
    },
]

class Header extends Component {
    constructor() {
        super();
        this.state = {
            channelsData: [],
            activeMenu: window.location.pathname,
            searchQuery: '',
            showSearch: false,
            mobileMenuOpen: false,
            mobileSearch: '',
            showProfileMenu: false,
        }
        this.handleMenu = this.handleMenu.bind(this);
        this.profileMenuRef = React.createRef();
    }

    componentDidMount() {
        let appStorage = window.app.storage;
        let siteConfig = window.site.config;

        // Handle Cognito redirect — token arrives as hash fragment (#id_token=...) or query param
        const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
        const cognitoToken = hashParams.get('id_token') || location('id_token');
        if (cognitoToken) {
            let lambdaUrl = window.site.submissionApiBaseUrl;
            let locationURL = window.location.protocol + '//' + window.location.host + '/';
            let url = lambdaUrl + '/authentication?appname=' + window.app.appName + '&token=' + cognitoToken + '&env=' + (window.app.appEnvName || 'dev') + '&host=' + locationURL;
            axios.post(url)
                .then((response) => {
                    if (response && response.data.statusCode === 200) {
                        let result = response.data.result || {};
                        appStorage.setItem('token', result.token);
                        appStorage.setItem('userCode', result.code);
                        appStorage.setItem('fullName', result.firstname + ' ' + result.lastname);
                        appStorage.setItem('userImage', result.userimage);
                        appStorage.setItem('firstname', result.firstname);
                        appStorage.setItem('lastname', result.lastname);
                        appStorage.setItem('email', result.emailid);
                        appStorage.setItem('user_id', result.userid);
                        appStorage.setItem('status', result.status);
                        appStorage.setItem('uid', result._id);
                        appStorage.setItem('usertype', result.usertype || '');
                        this.setState({
                            userId: result.userid,
                            userName: result.firstname + ' ' + result.lastname,
                            userImage: result?.userimage || '',
                        });
                        // Clean hash/query token from URL without reload
                        if (window.history.replaceState) {
                            window.history.replaceState(null, '', window.location.pathname);
                        }
                        // Creator users go directly to the creator page
                        if (result.usertype === 'creator' || result.usertype === 'partner') {
                            browserHistory.push('/creator');
                            return;
                        }
                        // Redirect based on profile completeness and subscription status
                        const appName = sessionStorage.getItem('preLoginUrlAppName') || window.app.urlAppName || window.app.appName;
                        sessionStorage.removeItem('preLoginUrlAppName');
                        const requiredFields = ['firstname', 'lastname', 'gender', 'mobileNumber'];
                        const profileComplete = requiredFields.every(f => !!(result[f] && result[f].toString().trim()));
                        if (!profileComplete) {
                            browserHistory.push('/profile?appname=' + appName);
                        } else {
                            const subscriptionId = result.subscriptionid || result.subscriptionplanid || false;
                            const isUnsubscribed = !subscriptionId || subscriptionId === 'free';
                            if (isUnsubscribed) {
                                browserHistory.push('/pricing?appname=' + appName);
                            } else {
                                browserHistory.push('/?appname=' + appName);
                            }
                        }
                    }
                })
                .catch((err) => console.error('Auth error:', err));
            return;
        }

        let firstName = appStorage.getItem('firstname');
        let lastName = appStorage.getItem('lastname');
        let userName = firstName + ' ' + lastName;
        let userId = appStorage.getItem('user_id');
        let userImage = appStorage.getItem('userImage');
        this.setState({ userName, userId, userImage });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.channels !== this.props.channels) {
            let channelsData = (this.props.channels || []);
            this.setState({ channelsData })
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this._handleOutsideClick);
    }

    _handleOutsideClick = (e) => {
        if (this.profileMenuRef.current && !this.profileMenuRef.current.contains(e.target)) {
            this.setState({ showProfileMenu: false });
        }
    }




    logOut(e) {
        if (window.site && window.site.config.authentication.key === "auth0") {
            if (window.signinLock) {
                window.signinLock.logout()
                console.log('logged out');
            }
        }
        e.stopPropagation();
        e.preventDefault();
        let appStorage = window.app.storage;
        const urlAppName = window.app.urlAppName || sessionStorage.getItem('urlAppName') || '';
        let appName = appStorage.getItem('appName') || localStorage.getItem('appName');
        let appEnvName = appStorage.getItem('appEnvName') || localStorage.getItem('appEnvName');
        let windowLocation = appStorage.getItem('windowLocation') || localStorage.getItem('windowLocation');
        appStorage.clear();
        localStorage.clear();
        sessionStorage.clear();
        if (appName) { appStorage.setItem('appName', appName); localStorage.setItem('appName', appName); }
        if (appEnvName) { appStorage.setItem('appEnvName', appEnvName); localStorage.setItem('appEnvName', appEnvName); }
        if (windowLocation) { appStorage.setItem('windowLocation', windowLocation); localStorage.setItem('windowLocation', windowLocation); }
        if (urlAppName) sessionStorage.setItem('urlAppName', urlAppName);
        window.location = '/?appname=' + (urlAppName || appName);
    };


    handleMenu = (e, item) => {
        e.preventDefault();
        let appStorage = window.app.storage;
        let appName = appStorage.getItem('appName');
        this.setState({ activeMenu: item.route })
        browserHistory.push(item.route + "?appname=" + (window.app.urlAppName || appName));
    }
    handleclick = (e) => {
        e.preventDefault();
        let appStorage = window.app.storage;
        let appName = appStorage.getItem('appName');
        browserHistory.push('/?appname=' + (window.app.urlAppName || appName));
    }

    profileClick = () => {
        const appStorage = window.app.storage;
        const isCreator = (appStorage.getItem && appStorage.getItem('usertype')) === 'creator' || (appStorage.getItem && appStorage.getItem('usertype')) === 'partner';
        browserHistory.push(isCreator ? '/creator' : '/profile');
    }
    activateDevice = () => {
        browserHistory.push('/activate');
    }
    pricingClick = () => {
        browserHistory.push('/pricing');
    }

    ManageAccount = () => {
        browserHistory.push('/account');
    }

    handleSearch = (e) => {
        e.preventDefault();
        const { searchQuery } = this.state;
        if (!searchQuery.trim()) return;
        let appStorage = window.app.storage;
        let appName = appStorage.getItem('appName');
        browserHistory.push('/search?q=' + encodeURIComponent(searchQuery.trim()) + '&appname=' + (window.app.urlAppName || appName));
    }

    handleLogin = () => {
        let siteConfig = window.site.config;
        let cognito = (siteConfig.authentication && siteConfig.authentication.cognito) || {};
        let cognitoClientId = cognito.clientId;
        let loginCognitoUrl = cognito.loginCognitoUrl;
        let cognitoTokenType = cognito.cognitoTokenType || 'token';
        if (loginCognitoUrl && cognitoClientId) {
            sessionStorage.setItem('preLoginUrlAppName', window.app.urlAppName || '');
            window.location = `${loginCognitoUrl}?client_id=${cognitoClientId}&response_type=${cognitoTokenType}&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=${window.location.origin}`;
        }
    }

    handleSignUp = () => {
        let siteConfig = window.site.config;
        let cognito = (siteConfig.authentication && siteConfig.authentication.cognito) || {};
        let cognitoClientId = cognito.clientId;
        let loginCognitoUrl = cognito.loginCognitoUrl;
        let cognitoTokenType = cognito.cognitoTokenType || 'token';
        if (loginCognitoUrl && cognitoClientId) {
            sessionStorage.setItem('preLoginUrlAppName', window.app.urlAppName || '');
            let signUpUrl = loginCognitoUrl.replace('/login', '/signup');
            window.location = `${signUpUrl}?client_id=${cognitoClientId}&response_type=${cognitoTokenType}&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=${window.location.origin}`;
        }
    }

    render() {
        let self = this;
        const { userName, userId, userImage, searchQuery, showSearch, mobileMenuOpen, mobileSearch, showProfileMenu } = self.state;
        let siteSettings = window.site;
        let siteConfig = siteSettings.config;
        let appName = window.app.storage.getItem('appName');
        let isLoggedIn = !!userId;
        const appStorage = window.app.storage;
        const isCreator = (appStorage.getItem && appStorage.getItem('usertype')) === 'creator' || (appStorage.getItem && appStorage.getItem('usertype')) === 'partner';

        let activeMenus = (window.app && window.app.urlAppName === 'heirloom') ? heirloomMenus : appName.includes('adidasboxing') || appName.includes('morehousecollege') || appName.includes('ganekimmersivestudios') || appName.includes('uclatheatre') || appName.includes('5120') ? adidasboxingMenus : appName === 'adidasboxing' ? adidasboxingMenus : appName.includes('1111') || appName.includes('tv6ghana') || appName.includes('kyliejenner') ? elevenMenus : appName.includes('kardashiancareers') ? kardashianMenus : appName.includes('paff') ? paffMenus : appName.includes('screenixx') ? screenixxMenus : appName.includes('marinadelreyfilmfestival') ? marinadelreyfilmfestivalMenus : appName.includes('usaboxing') || appName.includes('theducktales')  ? usaboxingMenus : appName.includes('westlosangelescollege') ? westlosangelescollegeMenus : appName.includes('hollyland') ? hollylandMenus : menus;

        return (
            <React.Fragment>
                <header className="fixed-top live-header">
                    <div className="container-fluid">
                        <nav className="navbar navbar-expand-md live-nav menu-click-animation">
                            <div className="nav-brand live-brand">
                                <button className="navbar-toggler" type="button" aria-label="Toggle navigation" onClick={() => self.setState({ mobileMenuOpen: true })}>
                                    <span className="material-symbols-outlined"> menu </span>
                                </button>
                                <a className="navbar-brand" onClick={(e) => this.handleclick(e)}>
                                    {window.app.urlAppName === 'heirloom' ? (
                                        <img src={heirloomLogo} />
                                    ) : (
                                        <img src={siteConfig?.defaultImages?.commonImages?.landingpageLogo} />
                                    )}
                                    

                                </a>
                            </div>

                            <div className="collapse navbar-collapse live-menu" id="navbarNav">
                                {!this.props.isTerms && <ul className="navbar-nav live-navlist">
                                    {activeMenus && activeMenus.length > 0 && activeMenus.map((menu, i) => {
                                        let menuClass = (self.state.activeMenu == menu.route) ? "nav-link active" : "nav-link";
                                        return (
                                            <li className="nav-item" key={i}>
                                                <a className={menuClass} aria-current="page" onClick={(e) => this.handleMenu(e, menu)} style={{ display: 'flex', gap: '5px' }}>
                                                    {menu.icon && <span className="material-symbols-outlined">{menu.icon}</span>}
                                                    {menu.menu}
                                                </a>
                                            </li>
                                        );
                                    })}
                                </ul>}

                                <div className="header-right ms-md-auto">
                                    {/* Search bar */}
                                    <form onSubmit={this.handleSearch} className="header-search-form">
                                        <input
                                            type="text"
                                            className={`header-search-input${showSearch ? ' open' : ''}`}
                                            placeholder="Search..."
                                            value={searchQuery}
                                            onChange={(e) => this.setState({ searchQuery: e.target.value })}
                                            ref={(el) => { if (showSearch && el) el.focus(); }}
                                        />
                                        <button
                                            type="button"
                                            className="header-search-btn"
                                            onClick={() => {
                                                if (showSearch && searchQuery.trim()) {
                                                    this.handleSearch({ preventDefault: () => { } });
                                                } else {
                                                    this.setState({ showSearch: !showSearch, searchQuery: '' });
                                                }
                                            }}
                                        >
                                            <span className="material-symbols-outlined">{showSearch ? 'close' : 'search'}</span>
                                        </button>
                                    </form>

                                    {/* Auth buttons */}
                                    {isLoggedIn ? (
                                        <div className="profile-dd" ref={this.profileMenuRef} style={{ position: 'relative' }}>
                                            <button
                                                className="header-profile-btn"
                                                type="button"
                                                onClick={() => {
                                                    const next = !showProfileMenu;
                                                    self.setState({ showProfileMenu: next });
                                                    if (next) document.addEventListener('mousedown', self._handleOutsideClick);
                                                    else document.removeEventListener('mousedown', self._handleOutsideClick);
                                                }}
                                            >
                                                {userImage && userImage !== 'undefined'
                                                    ? <img src={userImage} alt="profile" className="header-profile-avatar" />
                                                    : <span className="material-symbols-outlined">account_circle</span>
                                                }
                                                <span className="header-profile-name">{userName}</span>
                                                <span className="material-symbols-outlined" style={{ fontSize: '18px', opacity: 0.7 }}>expand_more</span>
                                            </button>
                                            {showProfileMenu && (
                                                <ul className="profile-dropdown-menu">
                                                    <li onClick={() => { self.setState({ showProfileMenu: false }); self.profileClick(); }}>
                                                        <span className="material-symbols-outlined">manage_accounts</span>My Profile
                                                    </li>
                                                    <li onClick={() => { self.setState({ showProfileMenu: false }); self.activateDevice(); }}>
                                                        <span className="material-symbols-outlined">devices</span>Activate Device
                                                    </li>
                                                    {!isCreator && <li onClick={() => { self.setState({ showProfileMenu: false }); self.pricingClick(); }}>
                                                        <span className="material-symbols-outlined">credit_card</span>Pricing
                                                    </li>}
                                                    <li className="divider" />
                                                    <li onClick={(e) => { self.setState({ showProfileMenu: false }); self.logOut(e); }}>
                                                        <span className="material-symbols-outlined">logout</span>Log Out
                                                    </li>
                                                </ul>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="header-auth-btns">
                                            <button className="btn-header-login" onClick={this.handleLogin}>Login</button>
                                            <button className="btn-header-signup" onClick={this.handleSignUp}>Sign Up</button>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </nav>
                    </div>
                </header>

                {mobileMenuOpen && (
                    <div className="mobile-fullscreen-menu">
                        <button className="mobile-menu-close" onClick={() => self.setState({ mobileMenuOpen: false })}>
                            <span className="material-symbols-outlined">close</span>
                        </button>

                        <form className="mobile-menu-search" onSubmit={(e) => {
                            e.preventDefault();
                            if (!mobileSearch.trim()) return;
                            let appName = window.app.storage.getItem('appName');
                            self.setState({ mobileMenuOpen: false });
                            browserHistory.push('/search?q=' + encodeURIComponent(mobileSearch.trim()) + '&appname=' + (window.app.urlAppName || appName));
                        }}>
                            <span className="material-symbols-outlined mobile-search-icon">search</span>
                            <input
                                type="text"
                                className="mobile-search-input"
                                placeholder="Search"
                                value={mobileSearch}
                                onChange={(e) => self.setState({ mobileSearch: e.target.value })}
                                autoFocus
                            />
                        </form>

                        <nav className="mobile-menu-nav">
                            {activeMenus.map((menu, i) => (
                                <a key={i} className="mobile-menu-item" onClick={() => {
                                    let appName = window.app.storage.getItem('appName');
                                    self.setState({ mobileMenuOpen: false });
                                    browserHistory.push(menu.route + '?appname=' + (window.app.urlAppName || appName));
                                }}>
                                    {menu.icon && <span className="material-symbols-outlined">{menu.icon}</span>}
                                    {menu.menu}
                                </a>
                            ))}
                        </nav>

                        <div className="mobile-menu-auth">
                            {!isLoggedIn ? (<>
                                <button className="mobile-signup-btn" onClick={() => { self.setState({ mobileMenuOpen: false }); self.handleSignUp(); }}>Sign Up</button>
                                <button className="mobile-login-btn" onClick={() => { self.setState({ mobileMenuOpen: false }); self.handleLogin(); }}>Log In</button>
                            </>) : (<>
                                <div className="mobile-user-info">
                                    {userImage != undefined && userImage !== 'undefined' && userImage !== ''
                                        ? <img src={userImage} alt="profile" className="mobile-user-avatar" />
                                        : <span className="material-symbols-outlined mobile-user-avatar-icon">account_circle</span>
                                    }
                                    <span className="mobile-user-name">{userName}</span>
                                </div>
                                <button className="mobile-menu-action-btn" onClick={() => { self.setState({ mobileMenuOpen: false }); self.profileClick(); }}>
                                    <span className="material-symbols-outlined">manage_accounts</span> My Profile
                                </button>
                                <button className="mobile-menu-action-btn" onClick={() => { self.setState({ mobileMenuOpen: false }); self.activateDevice(); }}>
                                    <span className="material-symbols-outlined">devices</span> Activate Device
                                </button>
                                {!isCreator && <button className="mobile-menu-action-btn" onClick={() => { self.setState({ mobileMenuOpen: false }); self.pricingClick(); }}>
                                    <span className="material-symbols-outlined">credit_card</span> Pricing
                                </button>}
                                <button className="mobile-login-btn mobile-menu-logout-btn" onClick={(e) => { self.setState({ mobileMenuOpen: false }); self.logOut(e); }}>Log Out</button>
                            </>)}
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

const mapState = ({ loading }) => ({ loading });
const mapDispatch = {};
export default connect(mapState, mapDispatch)(Header);